export default __webpack_public_path__ + "static/entrepreneur-logo-6969b3475d2bf0822dcf9d2e992530e3.png";